import PropTypes from "prop-types";

import { Card, Form, FormTextarea } from "shards-react";
import { ResponsiblePrimaryButton } from "../../components/buttons/ResponsibleAmeButton";
import CheckBoxGroupComponent from "../../components/common/check-box-group-component/CheckBoxGroupComponent";
import MainCardComponent from "../../components/common/main-card-component/MainCardComponent";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";
import Loading from "../../components/loading/Loading";
import { CustomizedCardBody } from "./style";

import TargetSelect from "../../components/common/target-select/TargetSelect";
import elementWithAllText from "../../components/inputs/hocs/element-with-all-text/elementWithAllText";
import withLabelAndHelpText from "../../components/inputs/hocs/with-label-and-help-text/withLabelAndHelpText";

const TextAreaWithLabelAndHelpText = withLabelAndHelpText(FormTextarea);
const TargetDropdown = elementWithAllText(TargetSelect);

const FormRegister = ({
    isFetching,
    visible,
    alertMessage,
    isAdmin,
    miniApp,
    showInputError,
    actions,
    targetValue,
    hasWriteMiniAppScope
}) => {
    let inputOptions = {
        isAdmin,
        miniApp,
        isEditScreen: false,
        showInputError,
        hasWriteMiniAppScope
    };

    let checkBoxOptions = {
        miniApp,
        isAdmin,
        isEditScreen: false,
        hasWriteMiniAppScope
    };

    return isFetching ? (
        <Loading showBrand={false} message={"Cadastrando eitri-app"} />
    ) : (
        <Form onSubmit={actions.onSubmit}>
            <Card small className="mb-4">
                <CustomizedCardHeader
                    className={"border-bottom"}
                    initialName={"Formulário de Cadastro de Eitri-App"}
                />
                <CustomizedCardBody>
                    <div
                        className="mb-3 register-alert"
                        style={{
                            display: visible ? "block" : "none",
                            color: "red"
                        }}
                    >
                        {alertMessage}
                    </div>
                    <MainCardComponent
                        options={inputOptions}
                        handleInput={actions.handleInput}
                        miniApp={miniApp}
                    />

                    <TargetDropdown
                        label="Target*"
                        helptext="Application do eitri-app."
                        advicetext="Este campo é obrigatório. Por favor, selecione uma opção."
                        onchange={actions.changeTarget}
                        targetValue={targetValue}
                        showerror={
                            showInputError && miniApp.target === "no_opt"
                        }
                    />
                    <hr />
                    <CheckBoxGroupComponent
                        options={checkBoxOptions}
                        handleSwitchStatus={actions.handleSwitchStatus}
                        handleSwitchChange={actions.handleSwitchChange}
                        onTogglePermission={actions.onTogglePermission}
                    />

                    <div>
                        <hr />
                        <TextAreaWithLabelAndHelpText
                            label={"Descricao"}
                            readOnly={!hasWriteMiniAppScope}
                            name={"description"}
                            value={miniApp.description || ""}
                            helptext={"Inserir descrição do eitri-app"}
                            onChange={actions.handleInput}
                            rows={10}
                        />
                        <ResponsiblePrimaryButton
                            name="bt-register-block"
                            type="submit"
                        >
                            Cadastrar eitri-app
                        </ResponsiblePrimaryButton>
                    </div>
                </CustomizedCardBody>
            </Card>
        </Form>
    );
};

FormRegister.propTypes = {
    isFetching: PropTypes.bool,
    visible: PropTypes.bool,
    alertArea: PropTypes.string,
    alertTheme: PropTypes.string,
    alertMessage: PropTypes.string,
    isAdmin: PropTypes.bool,
    hasWriteMiniAppScope: PropTypes.bool,
    miniApp: PropTypes.object,
    context: PropTypes.any,
    showInputError: PropTypes.bool,
    collapse: PropTypes.bool,
    actions: PropTypes.object,
    targetValue: PropTypes.string
};

export default FormRegister;
